import types from "../types";

export const fetchenrollment = (enrollments) => ({
  type: types.enrollmentTypes.FETCH_ENROLLMENT_SUCCESS,
  payload: enrollments,
});
